module.exports = __webpack_public_path__ + "assets/img/pv-systems.aea47fa2.jpg";